import React from "react";

const CheckIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="check_icon"
      data-name="check"
      {...props}
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66656 10.3907L4.47123 8.19539L3.52856 9.13806L6.66656 12.2761L13.1379 5.80473L12.1952 4.86206L6.66656 10.3907Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
};

export default CheckIcon;
